import React, { useMemo } from 'react';

import { cn } from '@shared/utils/lib/ui';

import { AssetColors } from '@utils/assets';

import { ThumbnailProps, thumbnailVariants, getCounterTextSize, getLabelTextSize } from './Thumbnail.styles';
import { ThumbnailAsset } from './ThumbnailAsset';
import { Body, Numeric } from '../Typography';

const Thumbnail: React.FC<ThumbnailProps> = ({
  bgColor,
  iconColor,
  textColor = 'primary',
  appearance,
  size,
  type,
  icon,
  count,
  label,
  assetCode = 'UNKNOWN',
  className,
}) => {
  const content = useMemo(() => {
    switch (type) {
      case 'icon':
        return React.createElement(icon, { className: cn('h-full w-full', iconColor) });
      case 'counter':
        return (
          <Numeric color={textColor} size={getCounterTextSize(size)} weight='extraBold'>
            {count}
          </Numeric>
        );
      case 'label':
        return (
          <Body color={textColor} size={getLabelTextSize(size)} weight='bold'>
            {label.charAt(0)}
          </Body>
        );
      case 'asset':
        return <ThumbnailAsset assetCode={assetCode} size={size} />;
    }
  }, [assetCode, count, icon, iconColor, label, size, textColor, type]);

  const thumbnailColor = useMemo(() => {
    if (type === 'asset') return AssetColors[assetCode];

    return bgColor;
  }, [assetCode, bgColor, type]);

  return (
    <span
      className={cn(
        thumbnailVariants({ size, appearance }),
        thumbnailColor,
        type === 'asset' && 'icon',
        className,
        'relative overflow-hidden',
      )}
      style={{ backgroundColor: type === 'asset' ? AssetColors[assetCode] : '' }}
    >
      {content}
    </span>
  );
};

export { Thumbnail };
